var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#333D4B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M45.004 30.063c0-1.02-.084-2.045-.264-3.048H30.305v5.776h8.266a6.936 6.936 0 0 1-3.06 4.558v3.748h4.933c2.896-2.612 4.56-6.47 4.56-11.034"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M30.307 44.718c4.127 0 7.608-1.328 10.144-3.62l-4.931-3.749c-1.372.915-3.144 1.433-5.208 1.433-3.992 0-7.377-2.64-8.592-6.19h-5.09v3.864c2.599 5.066 7.89 8.262 13.677 8.262"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M21.715 32.593a8.815 8.815 0 0 1 0-5.744v-3.863h-5.083a14.747 14.747 0 0 0 0 13.47z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M30.307 20.655a8.41 8.41 0 0 1 5.87 2.248l4.37-4.282c-2.767-2.547-6.439-3.947-10.24-3.902-5.787 0-11.078 3.196-13.676 8.267l5.083 3.864c1.21-3.555 4.6-6.195 8.593-6.195"
  })));
};
export default SvgGoogle;